import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, moduleTypeNames } from "../../../framework/core/mvvm/module_base";
import ViewBase from "../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir, ListItem } from "../../../framework/tools/scrollview/listview";
import ClubMemberItem from "../component/club_member_item";
import { club_utils } from "../club_utils";
import ClubMemberBase from "../component/club_member_base";


const {ccclass, property} = cc._decorator;

 export enum member_page{
    member = 0,
    audit,
    log,
    searchMember,
    searchAudit,
}

@ccclass
export default class ClubMemberView extends ViewBase {

    @property(cc.ScrollView)
    scrollView : cc.ScrollView = null;

    @property(cc.Node)
    content : cc.Node = null;

    @property(cc.Node)
    view : cc.Node = null;

    @property([cc.Node])
    itemPrefabs : cc.Node[] = [];

    @property(cc.EditBox)
    serachEditBox : cc.EditBox = null;

    @property([cc.Toggle])
    toggleList : cc.Toggle[] = [];

    @property(cc.Node)
    titleToggle : cc.Node = null;
     
    private cur_member_page : number = 1;

    private cur_audit_page : number = 1;

    private cur_log_page : number = 1;

    private listView : ListView = null;

    curType : member_page = member_page.member;
    clubId : number;

    onLoad(){

        this.serachEditBox.node.on('text-changed', this.onSerach, this);

        this.eventBind("club_member_update_rank",this.on_club_member_update_rank);
    }

    private reset(){
        this.cur_member_page = 1;
        this.cur_audit_page = 1;
        this.cur_log_page = 1;
    }

    private onSerach(){

        if(!this.serachEditBox.string.match("^[0-9]*$")){
            this.serachEditBox.string = this.serachEditBox.string.substring(0, this.serachEditBox.string.length - 1);
            this.serachEditBox.blur();
        }
    }

    private on_club_member_update_rank(index:number,data : any){

        if (data.gameUserId == club_utils.avatarId) {
            
            this.titleToggle.active = data.clubUserType == "admin" || data.clubUserType == "owner";
        }     

    }


    updateBanlace(index : number,currency : number){

        let item = this.listView.items[index];
        let memberCom = item.node.getComponent(ClubMemberBase);
        if (memberCom) {
            memberCom.updateCurrency(currency);
        }
    }

    public getListItemData(index : number){

        return this.listView.items[index].data;
    }


    onScroll(sender,event){
    
        if(event == 4){
            
            let self = this;
            if (this.curType == member_page.member) {

                if (club_utils.memberList.length <= this.listView.stop_index + 1) {
                    
                    club_utils.reqMemberList(++this.cur_member_page,this,(datalist)=>{
                        datalist.forEach(data => {
                            self.addItem(datalist);
                        });
                        
                    },undefined,true);                       
                }

            }else if(this.curType == member_page.audit){

                if (club_utils.auditList.length <= this.listView.stop_index + 1) {
                    
                    club_utils.reqAuditList(++this.cur_audit_page,this,(datalist)=>{
                        datalist.forEach(data => {
                            self.addItem(datalist);
                        });
                    },undefined,true);                       
                }

            }else if(this.curType == member_page.log){

                if (club_utils.logList.length <= this.listView.stop_index + 1) {
                    
                    club_utils.reqLogList(++this.cur_log_page,this,(datalist)=>{
                        datalist.forEach(data => {
                            self.addItem(datalist);
                        });
                    },true);                       
                }

            }               
            console.log( " onScroll " ,this.listView.stop_index );
             
        }
        
    }

    private getCurList(){
        
        let dataList : any[] = [];
        switch(this.curType){
            case(member_page.member):
                dataList = club_utils.memberList;
                break;
            case(member_page.audit):
                dataList = club_utils.auditList;
                break;
            case(member_page.log):
                dataList = club_utils.logList;
                break;
            case(member_page.searchMember):
                dataList = club_utils.searchMemberList;
                break;
            case member_page.searchAudit:
                dataList = club_utils.searchAuditList;    
        }

        return dataList;
    }

    refreshMemberList(){

        if (this.curType == member_page.member) {
            this.requestMember();
            this.updateListView();
        }
    }

    refreshAudiList(){

        if (this.curType == member_page.audit) {
            this.requestAudit();
            this.updateListView();
        }
    }

    refreshLogList(){

        if (this.curType == member_page.log) {
            this.requestLog();
            this.updateListView();
        }
    }

    onToggleMember(){

        this.curType = member_page.member;

        this.refreshMemberList();
    }

    onToggleLog(){

        this.curType = member_page.log;

        this.refreshLogList();
    }

    onToggleExamine(){

        this.curType = member_page.audit;

        this.refreshAudiList();
    }

    updateListView(){

        if (this.listView) {
            
            this.listView.destroyListView();
        }

        let list : ListView = new ListView({
            scrollview: this.scrollView,
            view: this.view,
            content: this.content,
            item_prefab:  this.itemPrefabs[this.curType],
            cb_host: this,
            item_update_func: this.itemUpdate,
            select_cb: null,
            column:  this.curType == member_page.log ? 1 : 2,
            row: 1,
            gap_y: 1,
            direction: ListViewDir.Vertical,
        });

        this.listView = list;

    
        this.listView.set_data(this.getCurList());    
                
    }

    addItem(data : any){

        this.listView.append_data(data);
    }

    removeItem(index : number){

        this.listView.remove_data(index);
    }

    private itemUpdate(item : cc.Node,data:any,index :number){

        let baseItem = item.getComponent(ClubMemberBase);

        baseItem.itemIndex = index;

        baseItem.updateInfo(data);
    }

    onShow(arg : any){
        super.onShow(arg);    
        
        if (this.toggleList.length > 0) {
            
            this.toggleList[0].check();
        }

        this.reset();

        this.onToggleMember();

        this.titleToggle.active = club_utils.isAdmin;                     
        
    }

    requestMember(){        

        let self = this;
        club_utils.reqMemberList(1,this,(dataList : any[])=>{
            self.updateListView();
        });
        
    }

    requestAudit(){
     
        let self = this;
        club_utils.reqAuditList(1,this,(datList : any[])=>{
            self.updateListView();
        });
        
    }

    requestLog(){

        let self = this;
        club_utils.reqLogList(1,this,(datList : any[])=>{
            self.updateListView();
        });

    }

    


}
